import React, { useEffect, useState } from 'react';
import {
  Box,
  CssBaseline,
  CircularProgress,
  Backdrop,
  Snackbar,
} from '@mui/material';
import { Profile, ChangePassword } from "../Model/Auction";
import { getUser } from "../../Model/LocalStorage";
import { FONT, accountRootSx } from "./accountStyles";
import { useAccountEmbedded } from "./components/AccountContext";
import { initialsOf } from "./components/AccountHeader";
import AccountLayout from "./components/AccountLayout";
import { AccountSection } from "./components/AccountSection";
import ProfileDetails from "./components/ProfileDetails";
import PasswordForm from "./components/PasswordForm";



const AccountPage = () => {
  const [user, setUser] = useState({ firstname: '', lastname: '', email: '', phone: '' });
  const [password, setPassword] = useState('');
  const [old_password, setOldPassword] = useState('');
  const [password_confirm, setPasswordConfirm] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '' });

  const getProfile = async () => {
    setLoading(true);
    try {
      const results = await Profile();
      if (results?.data?.length > 0) {
        setUser(results.data[0]);
      }
    } catch (error) {
      console.error("Profile fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProfile();
    const fetchLocalUser = async () => {
      try {
        const getuser = await getUser();
        if (getuser?.drowssap) setOldPassword(getuser.drowssap);
      } catch (e) {
        console.error("Local storage error:", e);
      }
    };
    fetchLocalUser();
  }, []);

  const handleSave = async () => {
    setSubmitted(true);
    if (!password || !password_confirm) return;
    if (password !== password_confirm) {
      setSnackbar({ open: true, message: "Passwords do not match." });
      return;
    }

    setLoading(true);
    try {
      const Info = { 
        oldPassword: old_password, 
        newpassword: password, 
        confirmPassword: password_confirm 
      };
      const results = await ChangePassword(Info);
      setSnackbar({ open: true, message: results.msg || "Password updated successfully." });
      setPassword('');
      setPasswordConfirm('');
      setSubmitted(false);
    } catch (error) {
      setSnackbar({ open: true, message: "An error occurred during update." });
    } finally {
      setLoading(false);
    }
  };

  const embedded = useAccountEmbedded();

  const sections = (
    <>
      <AccountSection
        first
        id="profile-information-title"
        title="Personal Information"
        description="The details registered to your León Gallery account."
      >
        <ProfileDetails user={user} />
      </AccountSection>

      <AccountSection
        id="profile-security-title"
        title="Security"
        description="Change the password you use to sign in."
      >
        <PasswordForm
          password={password}
          onPasswordChange={(e) => setPassword(e.target.value)}
          passwordConfirm={password_confirm}
          onPasswordConfirmChange={(e) => setPasswordConfirm(e.target.value)}
          showPassword={showPassword}
          onToggleShowPassword={() => setShowPassword(!showPassword)}
          showConfirmPassword={showConfirmPassword}
          onToggleShowConfirmPassword={() => setShowConfirmPassword(!showConfirmPassword)}
          submitted={submitted}
          onSave={handleSave}
        />
      </AccountSection>
    </>
  );

  return (
    <Box sx={{ ...accountRootSx, bgcolor: '#fff' }}>
      <CssBaseline />
      {embedded ? (
        sections
      ) : (
        <AccountLayout
          title="Profile"
          subtitle={user.email}
          initials={initialsOf(user.firstname, user.lastname)}
        >
          {sections}
        </AccountLayout>
      )}

      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" thickness={2} />
      </Backdrop>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        ContentProps={{
          sx: { fontFamily: FONT, borderRadius: 0 }
        }}
      />
    </Box>
  );
};

export default AccountPage;
